import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

type HomeDestinationsChartLabelProps = {
  total: number;
};

const HomeDestinationsChartLabelComp: FC<HomeDestinationsChartLabelProps> = ({ total }) => {
  const { t } = useTranslation();

  return (
    <div className='absolute z-[-1] flex flex-col items-center justify-center rounded-full bg-white-100 shadow-sm'>
      <span className='text-xs font-medium text-tertiary-600'>{t('home:active')}</span>
      <span className='text-2xl font-semibold text-brand-600'>{total}</span>
    </div>
  );
};

export const HomeDestinationsChartLabel = memo(HomeDestinationsChartLabelComp);
